import { Password } from "primereact/password";
import {
  createAsyncThunk,
  createSlice,
  nanoid,
  PayloadAction,
} from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
import { useActionData } from "react-router-dom";
import { GetFileByEntityId } from "../../services/MediumService";
import { GetNoticesPaged } from "../../services/NoticeService";
import { log } from "@grpc/grpc-js/build/src/logging";

const initialState = {
  notices: [] as any,
  status: "idle",
  error: "" as string | undefined,
};

export const updateNotices = createAsyncThunk(
  "/notices/updateNotices",
  async (data: any) => {
    // const response = await GetFileByEntityId(data.id);

    // return { image: response.data, id: data.id };

    return { id: "", image: "" };
  }
);

export const fetchNotices = createAsyncThunk(
  "/notices/fetchNotices",
  async (data: any, thunkAPI) => {
    //console.log("ddds", data);

    const response = await GetNoticesPaged(
      data.skip,
      4,
      data.positionId,
      data.qry,
      data.categoryId,
      data.filter
    );
    //console.log("rrr", response.data);

    return response.data;
  }
);
export const searchNotice = createAsyncThunk(
  "/notices/searchNotice",
  async (data: any, thunkAPI) => {
    return await GetNoticesPaged(
      0,
      4,
      data.positionId,
      data.qry,
      data.categoryId,
      data.filter
    ).then((response) => {
      //console.log("rppr", response);

      return response.data;
    });
  }
);
export const emptyNotices = createAsyncThunk(
  "/notices/emptyNotices",
  async (thunkAPI) => {
    return null;
  }
);

export const pushNotice = createAsyncThunk(
  "/notices/pushNotice",
  async (data: any, thunkAPI) => {
    //console.log("frd", data.data);

    return data.data;
  }
);

const noticeSlice = createSlice({
  name: "notices",
  initialState: initialState,
  reducers: {
    noticeAdded: (state, action: PayloadAction<any>) => {
      state.notices.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotices.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchNotices.fulfilled, (state, action: PayloadAction<any>) => {
        action.payload.map((p: any) => {
          if (
            state.notices.findIndex((notice: any) => notice.id === p.id) < 0
          ) {
            state.notices.push(p);
          }
        });
        state.status = "idle";
      })
      .addCase(searchNotice.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(searchNotice.fulfilled, (state, action) => {
        //console.log("aap", action.payload);

        state.notices = action.payload;
        state.status = "idle";
      })
      .addCase(searchNotice.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "idle";
      })
      .addCase(emptyNotices.fulfilled, (state, action) => {
        state.notices = [];
      })
      .addCase(pushNotice.fulfilled, (state, action) => {
        state.notices = action.payload;
      })
      .addCase(fetchNotices.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(updateNotices.fulfilled, (state, action) => {
        const { id, image } = action.payload;

        const updatedNoticeIndex = state.notices.findIndex(
          (notice: any) => notice.id === id
        );
        //console.log(state.notices[updatedNoticeIndex]);

        //1402/07/29//state.notices[updatedNoticeIndex].image = image;
      });
  },
});

/*
     reducer(state, action: PayloadAction<any>) {
        state.notices.push(action.payload);
      },
      prepare(data) {
        // Complex Logic
        return {
          payload: {
            data,
          },
*/
export const selectAllNotices = (state: any) => state.notices.notices;
export const { noticeAdded } = noticeSlice.actions;

export default noticeSlice.reducer;
